import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Avatar,
  Box,
} from "@mui/material";

const App = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const message = form.message.value.trim();

    if (!name || !email || !message) {
      alert("Please fill in all fields");
      return;
    }
    if (!validateEmail(email)) {
      alert("Please enter a valid email");
      return;
    }
    alert(`Thank you for reaching out, ${name}! We will get back to you soon.`);
    form.reset();
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  return (
    <Box>
      <AppBar
        position="static"
        sx={{ background: "linear-gradient(to right, #1E3C72, #2A5298)" }}
      >
        <Toolbar>
          <img
            src="/matel.png"
            alt="Matel Logo"
            style={{ height: 120, marginRight: "auto" }}
          />
          {["Services", "Portfolio", "Testimonials", "About", "Contact"].map(
            (label) => (
              <Button
                key={label}
                color="inherit"
                href={`#${label.toLowerCase()}`}
              >
                {" "}
                {label}{" "}
              </Button>
            )
          )}
        </Toolbar>
      </AppBar>

      <Box
        id="hero"
        sx={{
          py: 20,
          textAlign: "center",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/team.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
        }}
      >
        <Container>
          <Typography variant="h3" gutterBottom fontWeight="bold">
            Grow Your Brand
            <br />
            with Matel Digital
          </Typography>
          <Typography variant="h6" paragraph>
            Your trusted partner for innovative digital marketing solutions.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() =>
              document
                .getElementById("contact")
                .scrollIntoView({ behavior: "smooth" })
            }
            sx={{
              backgroundColor: "#1f3e76",
              "&:hover": {
                backgroundColor: "#2a5298", // Hover effect
              },
            }}
          >
            Get Started
          </Button>
        </Container>
      </Box>

      <Box id="services" py={6}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight="bold"
          >
            Our Services
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {[
              {
                title: "SEO Optimization",
                desc: "Improve your website’s ranking with cutting-edge SEO strategies.",
              },
              {
                title: "Social Media Marketing",
                desc: "Engage your audience across platforms with targeted campaigns.",
              },
              {
                title: "Content Creation",
                desc: "Craft compelling content that drives conversions and loyalty.",
              },
            ].map((service, i) => (
              <Grid item xs={12} md={4} key={i}>
                <Paper
                  elevation={6}
                  sx={{
                    p: 3,
                    textAlign: "center",
                    borderRadius: 3,
                    "&:hover": { boxShadow: 10 },
                  }}
                >
                  <Typography variant="h6" fontWeight="medium">
                    {service.title}
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    {service.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box id="portfolio" py={6} bgcolor="#f9f9f9">
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight="bold"
          >
            Our Clients
          </Typography>
          <Grid container spacing={3} justifyContent="center">
            <Grid item key={1}>
              <img src="/all.png" alt={1} style={{ height: "60px" }} />
            </Grid>
            <Grid item key={2}>
              <img src="/sizzle.png" alt={1} style={{ height: "60px" }} />
            </Grid>
            <Grid item key={2}>
              <img src="/swift.png" alt={1} style={{ height: "60px" }} />
            </Grid>
            <Grid item key={2}>
              <img src="/chanak.jpg" alt={1} style={{ height: "60px" }} />
            </Grid>
            <Grid item key={2}>
              <img src="/season.jpeg" alt={1} style={{ height: "60px" }} />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box id="testimonials" py={6}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight="bold"
          >
            What Clients Say
          </Typography>
          {[
            {
              text: "Matel transformed our online presence and boosted our sales by 40%. Highly recommend!",
              author: "— Sarah M., Retail Store Owner",
            },
            {
              text: "The team is creative, professional, and responsive. Our social media engagement has never been better.",
              author: "— David L., Tech Startup CEO",
            },
            {
              text: "Thanks to MR’s content strategy, our blog traffic increased threefold in just six months.",
              author: "— Emma R., Marketing Manager",
            },
          ].map((t, i) => (
            <Paper
              key={i}
              elevation={4}
              sx={{ p: 3, mb: 3, borderLeft: "5px solid #1f3e76" }}
            >
              <Typography variant="body1">{t.text}</Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t.author}
              </Typography>
            </Paper>
          ))}
        </Container>
      </Box>

      <Box id="about" py={6} bgcolor="#f7f7f7">
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight="bold"
          >
            Meet Our Team
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {[
              {
                name: "Manav Ramani",
                title: "Chief Executive Officer",
                img: "/avatar.png",
              },
              {
                name: "Meet Vasani",
                title: "Content Strategist",
                img: "/avatar.png",
              },
            ].map((member, i) => (
              <Grid item key={i}>
                <Avatar
                  src={member.img}
                  alt={member.name}
                  sx={{ width: 100, height: 100, margin: "0 auto" }}
                />
                <Typography align="center" variant="h6">
                  {member.name}
                </Typography>
                <Typography
                  align="center"
                  variant="body2"
                  color="text.secondary"
                >
                  {member.title}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box id="contact" py={6}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight="bold"
          >
            Contact Us
          </Typography>
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Name" name="name" required />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Message"
                  name="message"
                  multiline
                  rows={4}
                  required
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    backgroundColor: "#1f3e76",
                    "&:hover": {
                      backgroundColor: "#2a5298", // Hover effect
                    },
                  }}
                >
                  Send Message
                </Button>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Box>

      <Box
        component="footer"
        py={3}
        bgcolor="#1e1e1e"
        color="white"
        textAlign="center"
      >
        &copy; 2024 Matel Digital Marketing Agency. All rights reserved.
      </Box>
    </Box>
  );
};

export default App;
